module.exports = __webpack_public_path__ + "static/media/stc_logo.80ff81e7.jpg";